import { NATION_FLAG } from "./images";

export type NationInfoProps = {
  name: string;
  phoneId: string;
  image: string;
  fullname: string;
};

const nationInfoList: NationInfoProps[] = [
  {
    name: "vietnam",
    fullname: "Việt Nam",
    phoneId: "+84",
    image: NATION_FLAG.VN_FLAG,
  },
  {
    name: "usa",
    fullname: "United States",
    phoneId: "+1",
    image: NATION_FLAG.US_FLAG,
  },
  {
    name: "singapore",
    fullname: "Singapore",
    phoneId: "+65",
    image: NATION_FLAG.SING_FLAG,
  },
  {
    name: "australia",
    fullname: "Australia",
    phoneId: "+61",
    image: NATION_FLAG.AU_FLAG,
  },
];

export default nationInfoList;
